"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M22.5 18a.5.5 0 0 1 .492.41l.008.09V23H1v-4.5a.5.5 0 0 1 .992-.09L2 18.5V22h20v-3.5a.5.5 0 0 1 .5-.5ZM12.001 2c.253 0 .463.185.507.427l.008.093v15.718l5.604-5.604a.515.515 0 0 1 .788.657l-.06.071-6.483 6.484a.515.515 0 0 1-.666.054l-.065-.054-6.483-6.484a.515.515 0 0 1 .657-.788l.071.06 5.607 5.607V2.52c0-.285.23-.52.515-.52Z",
    clipRule: "evenodd"
  })]
});